// JS
import React, { useEffect, useState } from 'react';
import Slider from '../Slider';
import {
  randomId,
  checkImgPath,
  renderHTMLspan,
  useTailwindMediaQuery,
  ppHeadingOverridesOpen
} from '../shared/utils';

// COMPONENT
const ProductRecommendations = ({
  prodRecsTitle,
  simpleData,
  currency,
  setQuickViewProdId,
  setShowHideQuickView,
  blackFriday,
  isSale,
  prodCode,
  recsID,
  setProdRecs
}) => {
  const [data, setData] = useState(null);
  const isMobile = useTailwindMediaQuery('sm');

  useEffect(() => {
    if (prodCode) {
      recsID.endPointPrams.append('pagevalue', prodCode);

      fetch(recsID.endPointUrl, {
        method: 'POST',
        body: recsID.endPointPrams
      })
        .then((response) => response.json())
        .then((data) => {
          setProdRecs(data);
        });
    }
  }, [prodCode, recsID, setProdRecs]);

  useEffect(() => {
    if (simpleData && simpleData.data) {
      setData(simpleData?.data.products.products);
    }
  }, [simpleData]);

  return (
    <section className="product-recommendations">
      <div className="product-recommendations-title">
        <h3 className={isSale && 'text-[#DA0018]'}>{prodRecsTitle}</h3>
      </div>
      <Slider
        useScrollbar={true}
        useMousewheel={!isMobile && true}
        useFreemode={!isMobile && true}
        usePagination={true}
        usePaginationDynamic={true}
        responsive={{
          sm: {
            show: 1,
            spaceBetween: 10
          },
          md: {
            show: 3.25
          },
          xl: {
            show: 4.25,
            spaceBetween: 15
          },
          '2xl': {
            show: 5.25
          }
        }}
        paginationOptions={{
          rounded: true,
          noContain: false,
          classes: {
            wrapper: '!block !mt-0 md:!hidden'
          }
        }}
        scrollbarOptions={{
          classes: 'hidden md:block'
        }}
      >
        {data &&
          data.map((slide, i) => (
            <a
              key={'just-landed-slide-col-1-[' + i + ']'}
              aria-label="Open Quick View"
              data-type="collection-prod"
              data-ga-track-clicks="true"
              data-id={slide.product.productid}
              data-list="Seven PDP Recommendations Page"
              data-brand={slide.product.attributes.brand}
              data-category={slide.product.attributes.product_category[0]}
              data-name={slide.product.name}
              data-position={i + 1}
              data-price={slide.product.option.promotionpriceasnumber}
              data-promotion-price={slide.product.option.promotionpriceasnumber}
              data-quantity={1}
              data-variant={
                slide.product.attributes.colour &&
                slide.product.attributes.colour[0]
              }
              data-currency={currency}
              onClick={(e) => {
                e.preventDefault();
                setShowHideQuickView(true);
                setQuickViewProdId(slide.product.productid);
                ppHeadingOverridesOpen();
              }}
            >
              <div key={randomId + i} className="product-recs-body-wrapper">
                {blackFriday && (
                  <div className="feed-bf-badge">
                    <p>25% Off</p>
                  </div>
                )}
                <img
                  src={checkImgPath(slide.product.image)}
                  className="product-recs-img"
                  alt={`${slide.product.attributes.brand} ${slide.product.name}`}
                />
                <div className="product-recs-body">
                  <div className="product-recs-img-heading">
                    {slide.product.attributes.brand}
                  </div>
                  <p className="product-recs-copy">
                    <span className="product-recs-product-name">
                      {slide.product.name}
                    </span>
                    {slide.product.option.onsale ? (
                      <span className="product-recs-product-price product-recs-product-price-more">
                        <span className="product-recs-product-og-price">
                          {renderHTMLspan(slide.product.option.price)}
                        </span>
                        <span className="product-recs-product-promo-price">
                          {renderHTMLspan(slide.product.option.promotionprice)}
                        </span>
                      </span>
                    ) : (
                      <span className="product-recs-product-price">
                        {renderHTMLspan(slide.product.option.price)}
                      </span>
                    )}
                  </p>
                </div>
              </div>
            </a>
          ))}
      </Slider>
    </section>
  );
};

export default ProductRecommendations;
